import React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '@interfaces';

export function EnvelopeIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                id="envelope"
                d="M448.93,111.84H78.39A39.21,39.21,0,0,0,39.23,151V393.84A39.21,39.21,0,0,0,78.39,433H448.93a39.21,39.21,0,0,0,39.16-39.16V151A39.21,39.21,0,0,0,448.93,111.84ZM466.75,151V393.84a17.84,17.84,0,0,1-17.82,17.82H78.39a17.84,17.84,0,0,1-17.82-17.82V151c0-.6,0-1.2.09-1.78l137.6,120L95.12,366.52a10.66,10.66,0,0,0-.47,15.08,10.74,10.74,0,0,0,7.78,3.37,10.58,10.58,0,0,0,7.31-2.91l104.68-98.72,20.76,18.11a44.5,44.5,0,0,0,57,0l20.77-18.11,104.52,98.34a10.67,10.67,0,1,0,14.63-15.53l-103-96.9,137.59-120C466.72,149.84,466.75,150.42,466.75,151ZM278.11,285.35c-7.69,6.72-21.2,6.72-28.91,0L75.11,133.5a17.8,17.8,0,0,1,3.28-.32H448.93a17.8,17.8,0,0,1,3.32.32Z"
            />
        </Icon>
    );
}
